import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"

import "./index.less"

import Fade from "react-reveal/Fade"
import ProgressBar from "../ProgressBar"
import WidgetOutcome from "../WidgetOutcome"
import MultiBarChart from "../MultiBarChart"
import WidgetHistoryEvolution from "../WidgetHistoryEvolution"
import { get, map } from "lodash"
import CardMember from "../CardMember"
import { isAmbassadorActive, isModuleBySlug } from "../../utils/storage"
import {
  AMBASSADOR_USERS,
  SCOPE_TYPE,
  SURVEY_CALCULATION_TYPE,
  WORKING_ENVIRONMENT_LABEL,
} from "../../utils/constants"
import { Divider } from "antd"
import EvolutionLineChart from "../../Reports/components/ReChart/EvolutionLineChart"
import emptyEvolution from "../../images/empty/evolution.svg"
import { validate } from "../../utils/functions"
import { loadImage, loadTexts } from "../../utils/i18n"
import { is } from "immutable"
import Carita_roja from "../../images/Carita_roja.svg"
import Carita_amarilla from "../../images/Carita_amarilla.svg"
import Carita_verde from "../../images/Carita_verde.svg"
import { Doughnut } from "react-chartjs-2"
export function ContentTopDimension(props) {
  const intlcontentTop = loadTexts("reports_dimensions_view")
    .contentTopDimension
  const intlcontentTopDimensionsLeadership = loadTexts(
    "reports_team_analysis_view"
  ).contentTopDimension
  const [isAmbassadorRole] = useState(isAmbassadorActive())
  const selectedDivisionInfo = props.divisions.find(
    (item) => item.id == props.selectedDivision
  )
  const [metricsChart, setMetricsChart] = useState({
    data: {
      datasets: [
        {
          data: [30, 60, 10],
          borderWidth: 0,
          backgroundColor: ["#5ad0b7", "#f9bf78", "#e88282"],
          weight: 0.3,
        },
      ],
      text: "10%",
    },
    options: {
      maintainAspectRatio: false,
      cutoutPercentage: 80,
      responsive: false,
      tooltips: { enabled: false },
      legend: { display: false },
      elements: {
        center: {
          text: "0%",
          color: "#4F4F4F", // Default is #000000
          fontStyle:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", sans-serif, Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans"', // Default is Arial
          sidePadding: 20, // Default is 20 (as a percentage)
          minFontSize: 12, // Default is 20 (in px), set to false and text will not wrap.
          lineHeight: 0, // Default is 25 (in px), used for when text wraps
        },
      },
    },
    plugins: [
      {
        beforeDraw(chart) {
          if (chart.config.options.elements.center) {
            // Get ctx from string
            var ctx = chart.chart.ctx

            // Get options from the center object in options
            var centerConfig = chart.config.options.elements.center
            var fontStyle = centerConfig.fontStyle || "Arial"
            var txt = centerConfig.text
            var color = centerConfig.color || "#000"
            var maxFontSize = centerConfig.maxFontSize || 75
            var sidePadding = centerConfig.sidePadding || 20
            var sidePaddingCalculated =
              (sidePadding / 100) * (chart.innerRadius * 2)
            // Start with a base font of 30px
            ctx.font = `20px ${fontStyle}`

            // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
            var stringWidth = ctx.measureText(txt).width
            var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated

            // Find out how much the font can grow in width.
            var widthRatio = elementWidth / stringWidth
            var newFontSize = Math.floor(30 * widthRatio)
            var elementHeight = chart.innerRadius * 2

            // Pick a new font size so it will not be larger than the height of label.
            var fontSizeToUse = Math.min(
              newFontSize,
              elementHeight,
              maxFontSize
            )
            var minFontSize = centerConfig.minFontSize
            var lineHeight = centerConfig.lineHeight || 25
            var wrapText = false

            if (minFontSize === undefined) {
              minFontSize = 20
            }

            // if (minFontSize && fontSizeToUse < minFontSize) {
            fontSizeToUse = minFontSize
            // wrapText = true
            // }

            // Set font settings to draw it correctly.
            ctx.textAlign = "center"
            ctx.textBaseline = "middle"
            var centerX = (chart.chartArea.left + chart.chartArea.right) / 2
            var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2
            ctx.font = `600 ${fontSizeToUse}px ${fontStyle}`
            ctx.fillStyle = color

            if (!wrapText) {
              ctx.fillText(txt, centerX, centerY)
              return
            }

            var words = txt.split(" ")
            var line = ""
            var lines = []

            // Break words up into multiple lines if necessary
            for (var n = 0; n < words.length; n++) {
              var testLine = `${line + words[n]} `
              var metrics = ctx.measureText(testLine)
              var testWidth = metrics.width
              if (testWidth > elementWidth && n > 0) {
                lines.push(line)
                line = `${words[n]} `
              } else {
                line = testLine
              }
            }

            // Move the center up depending on line height and number of lines
            centerY -= (lines.length / 2) * lineHeight

            for (var n = 0; n < lines.length; n++) {
              ctx.fillText(lines[n], centerX, centerY)
              centerY += lineHeight
            }
            // Draw text in center
            ctx.fillText(line, centerX, centerY)
          }
        },
      },
    ],
  })
  useEffect(() => {
    if (validate.exist(selectedDivisionInfo)) {
      const climeChartAux = { ...metricsChart }
      climeChartAux.data.datasets[0].data = [
        parseInt(selectedDivisionInfo.value_enps, 0),
        parseInt(selectedDivisionInfo.value_middle_enps, 0),
        parseInt(selectedDivisionInfo.value_low_enps, 0),
      ]
      climeChartAux.data.text =
        selectedDivisionInfo.value_enps_total == 0
          ? "0"
          : `${parseInt(selectedDivisionInfo.value_enps_total, 10)}`
      climeChartAux.options.elements.center.text =
        selectedDivisionInfo.value_enps_total == 0
          ? "0"
          : `${parseInt(selectedDivisionInfo.value_enps_total, 10)}`
      setMetricsChart(climeChartAux)
    }
  }, [selectedDivisionInfo])
  const renderSectionEngagement = () => {
    const {
      metricTotal,
      outcomes,
      isEngagement,
      isEngagementOnly,
      measureInfo,
      switchMoreDimensions,
      showHistory,
    } = props

    // if (!isEngagement) return ""

    return (
      <div className="ContentTopDimension-Resume">
        <div className="ContentTopDimension-Resume-Labels">
          {selectedDivisionInfo && (
            <Fragment>
              {isEngagement && (
                <>
                  <div className="ContentTopDimension-Resume-Engagement">
                    <span className="ContentTopDimension-Resume-Engagement-Text">
                      {intlcontentTop.engagement}
                    </span>
                    <span
                      className="ContentTopDimension-Resume-Engagement-Value"
                      style={{
                        backgroundColor: get(metricTotal, "color", "#F9F9F9"),
                      }}>
                      {get(metricTotal, "value_visible", "-")}
                    </span>
                  </div>
                  <Divider type="vertical" style={{ height: 26 }} />
                </>
              )}

              {!isEngagementOnly && (
                <Fragment>
                  <div className="ContentTopDimension-Resume-TotalResult">
                    <span className="ContentTopDimension-Resume-TotalResult-Text">
                      {setNameMetricsTotalLabel()}{" "}
                    </span>
                    <span
                      className="ContentTopDimension-Resume-TotalResult-Value"
                      style={{
                        backgroundColor: selectedDivisionInfo.color,
                      }}>
                      {selectedDivisionInfo.value_visible}
                    </span>
                  </div>
                  <Divider type="vertical" style={{ height: 26 }} />
                </Fragment>
              )}
              <div className="ContentTopDimension-Resume-ResponseRate">
                <span>{intlcontentTop.responseRate}</span>
                <ProgressBar
                  style={{ width: "150px" }}
                  custom={{
                    value_visible:
                      selectedDivisionInfo.response_rate.rate_visible,
                    color: selectedDivisionInfo.response_rate.rate_color,
                    value: selectedDivisionInfo.response_rate.rate,
                  }}
                />
              </div>
              {measureInfo.has_enps && measureInfo.id_survey_type == 2 && (
                <Fragment>
                  <Divider type="vertical" style={{ height: 26, color: '#EDE9E9' }} />
                  <div className="ContentTopDimension-Resume-nps">
                    <span className="ContentTopDimension-Resume-nps-Text" style={{ color: '#4F4F4F',marginRight:3 }}>NPS</span>
                    <span className="ContentTopDimension-Resume-nps-Text" style={{ color: '#979797' }}> (%)</span>
                  </div>
                  <div className="WidgetChartEnps-body-paddingEnps">
                    <div className="WidgetChartEnps-body-chartEnps" >
                      <Doughnut
                        data={metricsChart.data}
                        options={metricsChart.options}
                        width={35}
                        height={35}
                        plugins={metricsChart.plugins}>
                        <div className="WidgetChartEnps-body-chartEnps-text">
                          {metricsChart.data.text}
                        </div>
                      </Doughnut>

                    </div>
                    <div className="WidgetChartEnps-body-legendEnps">
                      <div className="WidgetChartEnps-body-legendEnps__green-enps">
                        <div style={{ marginBottom:2 }}>
                          <img width={16} height={16} src={Carita_verde} />
                          <span className="porcentaje">
                            {selectedDivisionInfo.value_enps + "%" || "-"}
                          </span>
                        </div>
                        <div className="nombre">
                          <span>Promotores  </span>
                          <span className="total">
                            ({selectedDivisionInfo.employees_top_enps || 0})
                          </span>
                        </div>
                      </div>
                      <div className="WidgetChartEnps-body-legendEnps__yellow-enps">
                        <div style={{ marginBottom:2 }}>
                          <img width={16} height={16} src={Carita_amarilla} />
                          <span className="porcentaje">
                            {selectedDivisionInfo.value_middle_enps + "%" || "-"}
                          </span>
                        </div>
                        <div className="nombre">
                          <span>Pasivos  </span>
                          <span className="total">
                            ({selectedDivisionInfo.employees_middle_enps || 0})
                          </span>
                        </div>
                      </div>
                      <div className="WidgetChartEnps-body-legendEnps__red-enps">
                        <div style={{ marginBottom:2 }}>
                          <img width={16} height={16} src={Carita_roja} />
                          <span className="porcentaje">
                            {selectedDivisionInfo.value_low_enps + "%" || "-"}
                          </span>
                        </div>
                        <div className="nombre">
                          <span>Detractores  </span>
                          <span className="total">
                            ({selectedDivisionInfo.employees_low_enps || 0})
                          </span>
                        </div>
                      </div>


                    </div>
                  </div>
                </Fragment>

              )}
            </Fragment>
          )}
        </div>
        {outcomes && !(switchMoreDimensions && showHistory) && (
          <div className="WidgetsGroupsBlock">
            <WidgetOutcome data={outcomes} measureGeneral={measureInfo} />
          </div>
        )}
      </div>
    )
  }

  const setNameMetricsTotalLabel = () => {
    const { measureInfo } = props
    let surveyType = get(measureInfo, "id_survey_calculation_type", 1)
    let hasLabel = get(measureInfo, "metric_total_label", null)
    let response = get(measureInfo, "survey_type_name", null)
    /* if (surveyType === SURVEY_CALCULATION_TYPE.topTwoBox) {
      response = get(measureInfo, "survey_type_name", null)
    } */
    return response
  }

  const renderMultiBarChart = () => {
    const {
      match,
      showHistory,
      switchMoreDimensions,
      graphicBars,
      isLoadingGraphicBars,
      graphicBarsWatcher,
      measureInfo,
      idSegment,
    } = props
    if (selectedDivisionInfo || !showHistory) {
      return null
    }
    return (
      <MultiBarChart
        {...graphicBars}
        match={match}
        hasDataHistory={switchMoreDimensions}
        loading={isLoadingGraphicBars}
        graphicBarsWatcher={graphicBarsWatcher}
        calculationType={get(measureInfo, "id_survey_calculation_type", 1)}
        idSegment={idSegment}
      />
    )
  }

  const renderHistoryEvolution = () => {
    const {
      isLoadingGraphicPeakon,
      evolutionData,
      evolutionLines,
      measureInfo,
      selectedDivision,metricTotal
    } = props
    if (measureInfo.id_measure_type == SCOPE_TYPE.typeSegment) {
      return null
    }

    if (isLoadingGraphicPeakon || selectedDivision == 'all') {
      return null
    }

    if (evolutionData?.length == 0 && evolutionLines?.length == 0) {
      return null
    }
    if(selectedDivision==null && (metricTotal?.id_division !== null)){
      return null
    }
    return (
      <div className="ContentTopDimension-HistoryEvolution">
        <div className="ContentTopDimension-HistoryEvolution-boxShadow">
          <div className="ContentTopDimension-HistoryEvolution-Title">
            {intlcontentTop.evolution}
          </div>
          {!validate.exist(evolutionLines) ||
            !Array.isArray(evolutionLines) ||
            evolutionData.length < 2 ? (
            <img
              className="ContentTopDimension-HistoryEvolution-Empty"
              src={loadImage(`empty/${intlcontentTop.imgEvolutionEmpty}`)}
            />
          ) : (
            <EvolutionLineChart data={evolutionData} lines={evolutionLines} isCalculationTopTwoBox={measureInfo.id_survey_calculation_type} />
          )}
        </div>
      </div>
    )
  }

  const renderListAmbassadors = () => {
    const { ambassadors } = props
    const isAmbassadorModule = isModuleBySlug(AMBASSADOR_USERS)
    return (
      <Fragment>
        {validRole({
          role: [1, 2, 3, 4],
        }) &&
          isAmbassadorModule &&
          selectedDivisionInfo &&
          Array.isArray(ambassadors) &&
          !!ambassadors.length && (
            <div style={{ marginTop: "1.25rem" }}>
              <div className="ReportsHome-create-header">
                <div className="ReportsHome-create-header-title">
                  <span style={{ color: "#888383", fontSize: "12px" }}>
                    Embajadores ({ambassadors.length})
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat( auto-fill, minmax(250px, 1fr) )",
                  gridGap: "30px 10px",
                  margin: "10px 0 30px",
                }}>
                {map(ambassadors, (item, index) => {
                  return (
                    <CardMember
                      key={index}
                      hideStatus
                      data={{
                        id_employee: item.id_ambassador,
                        picture_profile: item.profile_picture,
                        full_name: item.full_name,
                        position_name: item.position_name,
                      }}
                    />
                  )
                })}
              </div>
            </div>
          )}
      </Fragment>
    )
  }

  const renderListLeaders = () => {
    const { team, selectedDivisionInfo } = props
    return (
      <Fragment>
        {selectedDivisionInfo && Array.isArray(team) && !!team.length && (
          <div style={{ marginTop: "1.25rem" }}>
            <div className="ReportsHome-create-header">
              <div className="ReportsHome-create-header-title">
                <span style={{ color: "#888383", fontSize: "12px" }}>
                  {intlcontentTopDimensionsLeadership.team} (
                  {(Array.isArray(team) && team.length) || 0})
                </span>
              </div>
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat( auto-fill, minmax(250px, 1fr) )",
                gridGap: "30px 10px",
                margin: "10px 0 30px",
              }}>
              {map(team, (item, index) => {
                return <CardMember key={index} data={item} hideStatus />
              })}
            </div>
          </div>
        )}
      </Fragment>
    )
  }

  return (
    <div className="ContentTopDimension">
      {renderSectionEngagement()}
      {renderMultiBarChart()}
      {renderHistoryEvolution()}
      {renderListAmbassadors()}
      {renderListLeaders()}
    </div>
  )
}

ContentTopDimension.propTypes = {
  selectedDivisionInfo: PropTypes.object,
  checkboxExclude: PropTypes.bool,
  evolutionData: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  evolutionLines: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  divisionsAvailable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  measureInfo: PropTypes.object,
  changeDivision: PropTypes.func,
  changeExcludeCheckbox: PropTypes.func,
  match: PropTypes.object,
  outcomes: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  hasLeader: PropTypes.bool,
}

export default ContentTopDimension
